import { appendHtml } from "./utils/stringUtil";




export function ConfigHeadHtml(titulo: string | undefined) {
  const head = document.getElementsByTagName('head')[0];

  //\/\/\/\/
  //Basic
  appendHtml(head,
    `<meta charset="UTF-8" />
    <link rel="icon" type="image/svg+xml" href="src/assets/favicon.ico" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    `
  );

  //Font
  appendHtml(head,
    `<link
    href='https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap'
    rel='stylesheet'>`
  );

  //Title
  
  titulo && appendHtml(head,
    `<title>${titulo}</title>`
  );


     //Title
    appendHtml(head,
    `<link
      rel="stylesheet"
      href="https://unpkg.com/react-quill@1.3.3/dist/quill.snow.css"
    />`
    );









}